import React from 'react';
import { Star } from 'lucide-react';
import clsx from 'clsx';

interface RatingRequestMessageProps {
  /** Nota atual (null = ainda nao avaliou) */
  currentRating: number | null;
  /** Callback quando o cliente avalia (simulado pelo agente no admin) */
  onRate?: (rating: number) => void;
  /** Se true, mostra como somente leitura (ja avaliou) */
  readonly?: boolean;
}

/**
 * Componente que renderiza a solicitacao de avaliacao dentro do chat.
 * Aparece como uma mensagem especial apos o encerramento do chamado.
 */
export default function RatingRequestMessage({
  currentRating,
  onRate,
  readonly = false,
}: RatingRequestMessageProps) {
  const stars = [1, 2, 3, 4, 5];
  const labels: Record<number, string> = {
    1: 'Muito ruim',
    2: 'Ruim',
    3: 'Regular',
    4: 'Bom',
    5: 'Excelente',
  };

  return (
    <div className="mx-auto my-3 max-w-xs">
      <div className="rounded-2xl border border-green-200 bg-green-50 px-4 py-3 text-center shadow-sm">
        <p className="mb-2 text-sm font-medium text-gray-700">
          {currentRating ? 'Avaliação recebida!' : 'Como você avalia nosso atendimento?'}
        </p>

        <div className="flex items-center justify-center gap-1">
          {stars.map(star => (
            <button
              key={star}
              type="button"
              disabled={readonly || !!currentRating}
              onClick={() => onRate?.(star)}
              className={clsx(
                'rounded-full p-1 transition-all',
                currentRating && star <= currentRating ? 'text-amber-400' : 'text-gray-300',
                !readonly && !currentRating && 'hover:scale-110 hover:text-amber-400',
                (readonly || !!currentRating) && 'cursor-default',
              )}
            >
              <Star
                size={24}
                fill={currentRating && star <= currentRating ? 'currentColor' : 'none'}
              />
            </button>
          ))}
        </div>

        {currentRating && (
          <p className="mt-1 text-xs font-medium text-green-600">
            {labels[currentRating]} — {currentRating}/5
          </p>
        )}

        {!currentRating && !readonly && (
          <p className="mt-1.5 text-[11px] text-gray-400">Toque em uma estrela para avaliar</p>
        )}
      </div>
    </div>
  );
}
